var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("mobile-recovery", {
                staticClass: "px-1 mb-2",
                attrs: {
                  id: "landing-recovery",
                  "recovery-amount-in-cents":
                    _vm.savedEstimatedDevice.amountInCents,
                  "recovery-device-model": _vm.savedEstimatedDevice.deviceModel,
                  "manual-estimation": _vm.manualEstimation,
                  "simulator-modal-id": _vm.simulatorModalId,
                  "bonus-recovery-selector-link":
                    _vm.dto.bonusRecoveryDetails.link,
                  "bonus-recovery-selector-link-label":
                    _vm.dto.bonusRecoveryDetails.linkLabelLong,
                  messages: _vm.dto.mobileRecovery.messages,
                  visual: _vm.dto.mobileRecovery.visual,
                  shop: _vm.dto.shop,
                },
              }),
              _vm._v(" "),
              _c("mobile-recovery-simulator-modal", {
                attrs: {
                  "modal-id": _vm.simulatorModalId,
                  shop: _vm.dto.shop,
                  messages: _vm.dto.recoverySimulator,
                },
                on: { "update-recovery-simulation": _vm.updateRecoveryPrice },
              }),
              _vm._v(" "),
              _c("mobile-recovery-simulation-result-modal", {
                attrs: {
                  "modal-id": _vm.currentSimulationResultModalId,
                  shop: _vm.dto.shop,
                  messages: _vm.dto.recoverySimulator.result,
                  "estimated-device-price-in-cents":
                    _vm.estimatedDevice.amountInCents,
                  "estimated-device-model": _vm.estimatedDevice.deviceModel,
                },
                on: {
                  "new-simulation": _vm.newSimulation,
                  "save-simulation": _vm.saveSimulation,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("h2", {
            domProps: {
              innerHTML: _vm._s(_vm.dto.recoveryDetails.infosRecovery.title),
            },
          }),
          _vm._v(" "),
          _c("list-icon", {
            staticClass: "mb-1",
            attrs: {
              id: "list-icon-landing-recovery",
              "additional-item-classes": "text-dark fw-normal",
              "element-type": "ol",
              items: _vm.dto.recoveryDetails.infosRecovery.processItems,
              highlight: "",
              "no-border-bottom": "",
            },
          }),
          _vm._v(" "),
          _c(
            "ob1-expanding-accordion",
            {
              staticClass: "bg-gray2 px-1 mb-1",
              attrs: {
                "element-type": "h3",
                "link-title": _vm.dto.recoveryDetails.storeRecovery.title,
                "link-id": "store-button",
                "collapsed-block-id": "store-detail",
              },
            },
            [
              _c("list-chronological-order", {
                attrs: {
                  id: "list-chronological-landing-store-recovery",
                  items: _vm.dto.recoveryDetails.storeRecovery.stepList,
                  "no-border-bottom": true,
                },
              }),
              _vm._v(" "),
              _c("p", {
                directives: [
                  {
                    name: "msh-html",
                    rawName: "v-msh-html",
                    value: _vm.dto.recoveryDetails.storeRecovery.processTitle,
                    expression:
                      "dto.recoveryDetails.storeRecovery.processTitle",
                  },
                ],
                staticClass: "mb-0",
              }),
              _vm._v(" "),
              _c("p", {
                directives: [
                  {
                    name: "msh-html",
                    rawName: "v-msh-html",
                    value: _vm.dto.recoveryDetails.storeRecovery.processDetail,
                    expression:
                      "dto.recoveryDetails.storeRecovery.processDetail",
                  },
                ],
                staticClass: "mb-0",
                attrs: { id: "store-details" },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-center text-mw" },
                [
                  _c("ob1-liens", {
                    attrs: {
                      "is-button": "",
                      "with-arrow": true,
                      "modal-id": _vm.simulatorModalId,
                      "data-bs-toggle": "modal",
                      text: _vm.dto.recoveryDetails.infosRecovery
                        .estimationButtonLabel,
                      "accessibility-text":
                        _vm.dto.recoveryDetails.infosRecovery
                          .estimationButtonAccessibilityLabel,
                      "data-oevent-label": "vers_simulateur",
                      "data-oevent-category": "menu_reprise_en_boutique",
                      "data-oevent-action": "j_accede_au_simulateur  ",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ob1-expanding-accordion",
            {
              staticClass: "bg-gray2 px-1 mb-2",
              attrs: {
                "element-type": "h3",
                "link-title": _vm.dto.recoveryDetails.onlineRecovery.title,
                "link-id": "online-button",
                "collapsed-block-id": "online-detail",
              },
            },
            [
              _c("list-chronological-order", {
                attrs: {
                  id: "list-chronological-landing-online-recovery",
                  items: _vm.dto.recoveryDetails.onlineRecovery.stepList,
                  "no-border-bottom": true,
                },
              }),
              _vm._v(" "),
              _c("p", {
                directives: [
                  {
                    name: "msh-html",
                    rawName: "v-msh-html",
                    value: _vm.dto.recoveryDetails.onlineRecovery.processTitle,
                    expression:
                      "dto.recoveryDetails.onlineRecovery.processTitle",
                  },
                ],
                staticClass: "mb-0",
              }),
              _vm._v(" "),
              _c("p", {
                directives: [
                  {
                    name: "msh-html",
                    rawName: "v-msh-html",
                    value: _vm.dto.recoveryDetails.onlineRecovery.processDetail,
                    expression:
                      "dto.recoveryDetails.onlineRecovery.processDetail",
                  },
                ],
                staticClass: "mb-0",
                attrs: { id: "online-details" },
              }),
              _vm._v(" "),
              _c("p", {
                directives: [
                  {
                    name: "msh-html",
                    rawName: "v-msh-html",
                    value: _vm.dto.recoveryDetails.onlineRecovery.mention,
                    expression: "dto.recoveryDetails.onlineRecovery.mention",
                  },
                ],
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-center text-mw" },
                [
                  _c("ob1-liens", {
                    attrs: {
                      "is-button": "",
                      "with-arrow": true,
                      "modal-id": _vm.simulatorModalId,
                      "data-bs-toggle": "modal",
                      text: _vm.dto.recoveryDetails.infosRecovery
                        .estimationButtonLabel,
                      "accessibility-text":
                        _vm.dto.recoveryDetails.infosRecovery
                          .estimationButtonAccessibilityLabel,
                      "data-oevent-label": "vers_simulateur",
                      "data-oevent-category": "menu_reprise_en_ligne",
                      "data-oevent-action": "j_accede_au_simulateur",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("h2", {
            domProps: { innerHTML: _vm._s(_vm.dto.bonusRecoveryDetails.title) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row pb-1 mb-2 justify-content-center" }, [
            _c(
              "div",
              {
                staticClass: "col-12 col-md-8 px-0",
                class: _vm.isSoshShop ? "bg-primary3" : "bg-greige",
              },
              [
                _c(
                  "div",
                  { staticClass: "position-absolute" },
                  [
                    _c("ob1-tag", {
                      attrs: {
                        label: _vm.dto.bonusRecoveryDetails.tag,
                        "is-aria-hidden": "",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row justify-content-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-8 pb-2 px-1",
                      class: _vm.isSoshShop ? "pt-1" : "pt-4",
                    },
                    [
                      _c("div", { staticClass: "visual text-center" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.dto.bonusRecoveryDetails.visual,
                            alt: "",
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "h4 pt-1",
                        class: _vm.isSoshShop ? "text-white" : "",
                        attrs: {
                          "aria-label":
                            _vm.dto.bonusRecoveryDetails
                              .promiseAccessibilityLabel,
                        },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.dto.bonusRecoveryDetails.promiseLabel
                          ),
                        },
                      }),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-center pb-2" },
                  [
                    _c("ob1-boutons", {
                      attrs: {
                        "is-button": false,
                        href: _vm.dto.bonusRecoveryDetails.link,
                        "is-secondary": true,
                        target: "_blank",
                        label: _vm.dto.bonusRecoveryDetails.linkLabelShort,
                        "accessibility-text":
                          _vm.dto.bonusRecoveryDetails.linkAccessibilityLabel,
                        "data-oevent-label": "vers_selecteur_avec_filtre_bonus",
                        "data-oevent-category": "ajout_bonus_reprise",
                        "data-oevent-action": "decouvrir_notre_selection",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "ob1-expanding-accordion",
            {
              staticClass: "bg-gray2 px-1 mb-2",
              attrs: {
                "element-type": "h3",
                "link-title": _vm.dto.bonusRecoveryExample.title,
                "link-id": "bonus-button",
                "collapsed-block-id": "bonus-detail",
              },
            },
            [
              _c("recovery-bonus-part", {
                attrs: { "bonus-details": _vm.dto.bonusRecoveryExample },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-content-center text-mw" },
                [
                  _c("ob1-liens", {
                    attrs: {
                      href: _vm.dto.bonusRecoveryDetails.link,
                      target: "_blank",
                      text: _vm.dto.bonusRecoveryDetails.linkLabelShort,
                      "accessibility-text":
                        _vm.dto.bonusRecoveryDetails.linkAccessibilityLabel,
                      "with-arrow": true,
                      "data-oevent-label": "vers_selecteur_avec_filtre_bonus",
                      "data-oevent-category": "exemple_bonus",
                      "data-oevent-action": "decouvrir_notre_selection",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.dto.faq
            ? _c("section", [
                _c("h2", {
                  staticClass: "my-2",
                  domProps: { innerHTML: _vm._s(_vm.dto.faq.title) },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "accordion mb-1" },
                  _vm._l(_vm.dto.faq.questionList, function (textBlock, index) {
                    return _c(
                      "div",
                      { key: "faq-" + index },
                      [
                        _c(
                          "ob1-expanding-accordion-card",
                          {
                            attrs: {
                              "element-type": "h3",
                              "collapsed-block-id": "faq-text-" + index,
                              "link-id": "faq-link-" + index,
                              "link-title": textBlock.title,
                              "is-card-body-max-width": false,
                            },
                          },
                          [
                            _c("div", {
                              domProps: { innerHTML: _vm._s(textBlock.text) },
                            }),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "bg-gray2" }, [
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _c("mobile-recovery-legal-mentions", {
              attrs: {
                title: _vm.dto.legalMentions.title,
                messages: _vm.dto.legalMentions.messages,
                mentions: _vm.dto.legalMentions.mentions,
              },
            }),
            _vm._v(" "),
            _c("free-hands", { attrs: { text: _vm.dto.freeHandsText } }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-webview-none",
          class: _vm.isSoshShop ? "bg-gray2 py-1" : "bg-dark py-1",
        },
        [
          _c(
            "div",
            { staticClass: "container-fluid" },
            [
              _c("ob1-breadcrumb", {
                attrs: {
                  "aria-label": "Fil d'ariane",
                  "is-inverse": !_vm.isSoshShop,
                  items: _vm.dto.filArianeDTO.items,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("ob1-snack-bar", {
        ref: "savedSimulationSnackbar",
        attrs: {
          id: "simulation-snackbar",
          icon: "icon-tick-circle",
          label: _vm.dto.recoverySimulator.result.snackbarLabel,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }